// 覆盖物组件
import React, { useEffect, useState } from "react";
import classnames from 'classnames';
import { Popover, Tooltip } from 'antd'
import { CloseOutlined } from '@ant-design/icons'

export default ({ positionData, detailInfo, allGYDY, handleVisble }) => {
  const [data, setData] = useState([])
  // 获取设备状态文字
  const getStatusStr = (val) => {
    let str = (
      <div className="state-box-content-tag zhengchang-state">正常</div>
    );
    if (val.isGZDev) {
      str = <div className="state-box-content-tag yichang-state">故障</div>;
    }
    return str;
  };
  useEffect(() => {
    setData(positionData.stateBoxData)
  }, [positionData.stateBoxData])

  // 仪表类展示
  const showData = (item, index, data) => {
    let flag = false; //是否含有普通点位
    data.map(mm => {
      if (mm.hasNormalDev) {
        flag = true;
      }
    })
    return <div
      className="state-box-content-item"
      key={index}
    >
      <div className="txt-info">
        {flag && <span className={classnames({
          "status-tip-circle": true,
        })}></span>}
        <span className="txt">{item.deviceName}</span>
      </div>
      <div className="state-box-val"
        title={item.val + item.gatherDevPoiParUnit}>
        {item.val}
        {item.gatherDevPoiParUnit}
      </div>
    </div>
  }

  // 非仪表类展示
  const showStatus = (item, index, mm) => {
    return <div
      className="state-box-content-item"
      key={item.devId}
    >
      <div className="txt-info">
        <span className={classnames({
          "status-tip-circle": true,
          green: !item.isTZDev,
          yellow: item.isTZDev,
        })}></span>
        <span className="txt">{item.deviceName}</span>
      </div>
      <div>{getStatusStr(item)}</div>
    </div>
  }

  const redWarning = () => {
    // 黄色故障物红色告警展示
    positionData.coverBoxData.map((mm, idx) => {
      if (detailInfo[mm.id]) {
        mm.isGZ = false;
        detailInfo[mm.id].map((item, index) => {
          if (item.isGZDev) {
            mm.isGZ = true;
          }
        })
      }
    })
  }
  const updateData = (e, idx) => {
    let vis = JSON.parse(JSON.stringify(data))
    vis[idx].show = !vis[idx].show
    setData(vis)
  }
  return (

    <div className="main-state">
      {redWarning()}
      {
        // 工艺单元的设备数据
        data && data.map((mm, idx) => {
          // 工艺单元下是否含有故障设备
          let hasGZDev = 0;
          allGYDY.map((mItem) => {
            if (mItem.processunitValue == mm.id) {
              hasGZDev = mItem.alarm;
            }
          });
          return (
            <div className={classnames({
              'state-box': mm.show,
              'state-info-box': !mm.show,
              gzCls: hasGZDev == 1
            })}
              key={'all' + idx}
              // onClick={() => handleVisble(mm.name, mm.id)}
              style={mm.show ? mm.style : mm.infoStyle}>
              {mm.show &&
                <>
                  <div className="state-box-header">{mm.name} <div onClick={(e) => updateData(e, idx)} ><CloseOutlined /></div></div>
                  <div className="state-box-content" onClick={() => handleVisble(mm.name, mm.id)}
                    style={{ height: mm.style.conHeight }}>
                    {detailInfo[mm.id] &&
                      detailInfo[mm.id].map((item, index) => {
                        // 出水口瞬时流量和累计流量数据不显示
                        if ((mm.id == 'CSQ' && ((!item.gatherDevPointValue.includes("_LJLL")) && (!item.gatherDevPointValue.includes("_SSLL"))))
                          || mm.id != 'CSQ') {
                          // 判断设备是否是仪表
                          let isYiBiao = false;
                          allGYDY.map((mItem) => {
                            if (mItem.processunitValue == mm.id) {
                              mItem.displayVOList.map((nItem) => {
                                if (nItem.devId == item.devId) {
                                  if (nItem.controlType == 'Y') {
                                    isYiBiao = true;
                                    item = { ...item, ...nItem }
                                  }
                                }
                              })
                            }
                          });
                          // 工艺单元是否含有普通设备
                          item.hasNormalDev = false;
                          if (isYiBiao) {
                            return showData(item, index, detailInfo[mm.id])
                          } else {
                            item.hasNormalDev = true;
                            return showStatus(item, item.processunitId, mm)
                          }
                        }
                      })}
                  </div>
                  <div className={"state-line-box " + mm.lineBox} style={mm.lineStyle}>
                    <div className="state-line" ></div>
                    <div className="state-dot"></div>
                  </div>
                </>
                ||
                <div onClick={(e) => updateData(e, idx)}>
                  {mm.name}
                </div>}
            </div>
          )
        })
      }

      {/* 黄色覆盖物区域 */}
      {
        positionData.coverBoxData.map((item, index) => {
          return (
            <div
              key={'posy' + index}
              style={item.style}
              className={classnames({
                'cover-box': true,
                warn: item.isGZ
              })}
            ></div>
          )
        })
      }
      {/*管道流动 */}
      {
        positionData.pipeData && positionData.pipeData.map((item, index) => {
          return (
            <div
              key={'pos' + index}
              style={item.style}
              className={classnames({
                'pipe-box': true,
                'small': item.small || false
              })}
            >
              <div className="father" style={item.fatherStyle}>
                {(new Array(item.num)).fill('').map((v, i) => {
                  return (
                    <span key={'mov' + i} className="moveson" style={item.moStyle}></span>
                  )
                })}
              </div>
            </div>
          )
        })
      }
    </div>
  );
};
